/**
 * JourneyTitleScreen - Beautiful animated title screen
 * Matches existing PipGame TitleScreen quality
 */

import { useEffect, useState } from 'react';
import './JourneyTitleScreen.css';

export default function JourneyTitleScreen({ onStart, onExit }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Trigger entrance animations
    requestAnimationFrame(() => setMounted(true));
  }, []);

  // Phase icons to display
  const phaseIcons = ['🎈', '🏃', '🔗', '📝', '📈', '💬', '🎯', '🗣️', '⭐', '🚀'];

  return (
    <div className={`journey-title ${mounted ? 'mounted' : ''}`}>
      {/* Animated background */}
      <div className="journey-title__bg">
        <div className="journey-title__gradient" />
        <div className="journey-title__stars">
          {[...Array(25)].map((_, i) => (
            <div 
              key={i} 
              className="journey-title__star"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`,
              }}
            >
              {['⭐', '✨', '🌟', '💫'][Math.floor(Math.random() * 4)]}
            </div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="journey-title__content">
        {/* Logo badge */}
        <div className="journey-title__badge">
          <span className="journey-title__badge-icon">🐱</span>
          <span className="journey-title__badge-text">SPEECHFORMATION</span>
        </div>

        {/* Pip character */}
        <div className="journey-title__pip">
          <div className="journey-title__pip-body">
            <div className="journey-title__pip-face">
              <div className="journey-title__pip-eyes">
                <div className="journey-title__pip-eye" />
                <div className="journey-title__pip-eye" />
              </div>
              <div className="journey-title__pip-mouth" />
            </div>
            <div className="journey-title__pip-ears">
              <div className="journey-title__pip-ear journey-title__pip-ear--left" />
              <div className="journey-title__pip-ear journey-title__pip-ear--right" />
            </div>
          </div>
        </div>

        {/* Title */}
        <div className="journey-title__logo">
          <h1 className="journey-title__main">Pip's</h1>
          <h2 className="journey-title__sub">Journey</h2>
        </div>

        {/* Tagline */}
        <p className="journey-title__tagline">
          A Voice-Powered Adventure Through Speech Development
        </p>

        {/* Phase icons row */}
        <div className="journey-title__phases">
          {phaseIcons.map((icon, i) => (
            <span 
              key={i} 
              className="journey-title__phase-icon"
              style={{ animationDelay: `${0.5 + i * 0.1}s` }}
            >
              {icon}
            </span>
          ))}
        </div>

        {/* Stats */}
        <p className="journey-title__stats">
          10 Phases • 20 Levels • One Amazing Journey
        </p>

        {/* Buttons */}
        <div className="journey-title__buttons">
          <button 
            className="journey-title__btn journey-title__btn--play" 
            onClick={onStart}
          >
            <span className="journey-title__btn-icon">▶</span>
            Start Journey
          </button>
          
          <button 
            className="journey-title__btn journey-title__btn--back" 
            onClick={onExit}
          >
            ← Back to Games
          </button>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="journey-title__decor">
        <div className="journey-title__decor-item journey-title__decor-item--1">🎈</div>
        <div className="journey-title__decor-item journey-title__decor-item--2">🚀</div>
        <div className="journey-title__decor-item journey-title__decor-item--3">🎯</div>
        <div className="journey-title__decor-item journey-title__decor-item--4">💬</div>
      </div>
    </div>
  );
}
